import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const MaterialNavigationSidebar = styled.div<{ collapse: boolean }>`
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  width: 370px;
  transform: ${({ collapse }) =>
    collapse ? 'translate3d(-365px, 0, 0)' : 'translate3d(0, 0, 0)'};
  height: calc(100vh - 100px);
  transition: transform 0.5s ease;
  box-shadow: 5px 0 10px rgba(0, 0, 0, 0.15);
  display: none;
  position: absolute;

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: flex;
    flex-direction: column;
    
  }

  .collapseButton {
    position: absolute;
    background-color: ${({ theme }) => theme.UI_COLORS.light};
    width: 16px;
    height: 32px;
    border: none;
    outline: none;
    border-bottom-right-radius: 32px;
    border-top-right-radius: 32px;
    right: -16px;
    top: 40px;
    box-shadow: 5px 0 5px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    padding: 0 7px 0 0;

    & > div {
      transition: transform 0.3s ease;

      & > svg {
        fill: ${({ theme }) => theme.UI_COLORS.alert};
      }
    }
  }

  .menu-items-container {
    padding: 4rem 3.5rem;
    box-sizing: border-box;
    overflow-y: scroll;
    height: 100%;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.UI_COLORS.main_gray}
      ${({ theme }) => theme.UI_COLORS.background};

    ::-webkit-scrollbar {
      width: 0.5rem;
      height: 0.5rem;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px ${({ theme }) => theme.UI_COLORS.background};
      border-radius: 2px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.UI_COLORS.main_gray};
      border-radius: 2px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #f3be4d;
    }


`;

export const ChapterNavigationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div.label {
    margin: 1rem 0;
    padding-right: 1rem;
  }

  .progress-icon {
    padding-right: 0.5rem;
  }

  .tooltip-content {
    padding: 0 2rem;
  }
`;

export const ChapterNavigationItemDisabled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 2.7rem;
  color: ${({ theme }) => theme.UI_COLORS.medium_gray};
  padding-right: 1rem;
  cursor: default;

  & > div.label {
    margin: 1rem 0;
  }
`;

export const ChapterCollapseLabel = styled.div`
  margin-bottom: 1rem;
`;

export const ChapterCollapseToggle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    cursor: pointer;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.5rem;
    transition: transform 0.3s ease;

    svg {
      fill: ${({ theme }) => theme.UI_COLORS.alert};
    }
  }

  .content {
    width: 100%;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
    font-weight: 500;
    color: ${({ theme }) => theme.UI_COLORS.secondary};
  }
`;

export const SubjectLabel = styled.div`
  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
  font-weight: 700;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  margin-top: 2rem;
  margin-bottom: 1rem;
  padding-left: 2.5rem;

  .pill-break {
    &:after {
      content: '';
      border-bottom: 1px solid ${({ theme }) => theme.UI_COLORS.primary};
    }
  }
`;

export const MaterialLabel = styled(NavLink)`
  margin: 0.8rem 0 0.8rem 2rem;
  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  text-decoration: none;
  word-break: break-word;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  border-radius: 4px;
  display: flex;
  align-items: start;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  padding: 0 1rem;

  svg {
    margin-right: 1rem;
    width: 20px;
    margin-top: 6px;
  }

  .material-label {
    width: calc(100% - 2rem);
    padding: 0.7rem 0.5rem 0.7rem 0;
  }

  .status {
    margin-top: 7px;

    & > svg {
      width: auto;
      margin-right: 0;
      margin-top: 0;
    }
  }

  &:hover {
    border-color: ${({ theme }) => theme.UI_COLORS.primary};
  }

  &.active {
    border-color: ${({ theme }) => theme.UI_COLORS.info};
  }

  .not-visited {
    color: ${({ theme }) => theme.UI_COLORS.medium_gray};
  }
`;

export const MaterialNavigationSidebarMobile = styled.div<{
  collapse: boolean;
}>`
  background-color: ${({ theme }) => theme.UI_COLORS.background};
  transition: transform 0.5s ease;
  position: absolute;
  z-index: 7;
  width: 100%;
  transform: ${({ collapse }) =>
    collapse ? 'translate3d(-100%, 0, 0)' : 'translate3d(0, 0, 0)'};
  overflow-y: hidden;
  box-sizing: border-box;
  top: 100px;
  padding-bottom: 5rem;

  .menu-items-container {
    overflow-y: scroll;
    height: calc(100vh - 100px);

    @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
      height: auto;
    }
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: none;
    flex-direction: column;
  }
  ::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.UI_COLORS.background};
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.UI_COLORS.main_gray};
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #f3be4d;
  }
`;

export const ChapterNavigationItemMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.UI_COLORS.main_gray};
  padding: 1rem;
  margin: 2rem 1rem 1rem;

  & > div.label {
    font-size: 2.4rem;
    font-weight: 300;
  }
`;

export const PillNameMobile = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
  padding: 0 2rem;
  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
`;

export const MaterialLabelMobile = styled(NavLink)`
  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
  font-weight: 700;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  text-decoration: none;
  word-break: break-word;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border: 1px solid transparent;
  transition: all 0.3s ease;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin: 1rem;
  padding: 1.2rem 2rem;

  .material-label {
    width: calc(100% - 2rem);
  }

  .status {
    & > svg {
      width: auto;
      margin-right: 0;
      margin-top: 0;
    }
  }

  svg {
    margin-right: 1rem;
    width: 20px;
  }

  &:hover {
    border-color: ${({ theme }) => theme.UI_COLORS.primary};
  }

  &.active {
    border-color: ${({ theme }) => theme.UI_COLORS.info};
  }

  .not-visited {
    color: ${({ theme }) => theme.UI_COLORS.medium_gray};
  }
`;

export const BackToChapterButton = styled.button`
  background: transparent;
  border: none;
  outline: none;
  padding: 0;

  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }

  svg {
    fill: ${({ theme }) => theme.UI_COLORS.secondary};
    margin-right: 0.5rem;
  }
`;

export const LecturerMaterialBrake = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.UI_COLORS.main_gray};
  margin: 1rem 0 1rem 2rem;
`;
